import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { FooterModule } from 'app/partials/footer/footer.module';
import { MainNavbarModule } from 'app/partials/main-navbar/main-navbar.module';

import { IconsModule } from 'app/wipperoz-core/icons/icons.module';
import { StartModule } from 'app/wipperoz-core/start/start.module';
import { AboutRoutingModule } from './about-routing.module';
import { AboutComponent } from './about.component';
import { IntroComponent } from './intro/intro.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { JoinTodayModule } from 'app/partials/join-today/join-today.module';
import { WipperozNumbersModule } from 'app/partials/wipperoz-numbers/wipperoz-numbers.module';

@NgModule({
  declarations: [AboutComponent, IntroComponent, PrivacyComponent, TermsComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StartModule,
    AboutRoutingModule,
    FooterModule,
    MainNavbarModule,
    IconsModule,
    JoinTodayModule,
    WipperozNumbersModule
  ],
  exports: []
})
export class AboutModule {}
